<template>
    <div class="alt-custom-loading">
        <div class="loader"></div>
    </div>
</template>

<style lang="scss">
.alt-custom-loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    opacity: 0.7;
    background: #ffffff;
    bottom: 0;

    .loader {
        &:before {
            width: 0px;
            height: 0px;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -.5em;
            margin-top: -.5em;
            content: '';
            -webkit-animation: spin 1s ease-in-out infinite;
            animation: spin 1s ease-in-out infinite;
            background-size: cover;
            line-height: 1;
            text-align: center;
            font-size: 2em;
            color: rgba(0, 0, 0, .75);

            border: 16px solid #888;
            border-radius: 50%;
            border-top: 16px solid #f3f3f3;
            overflow: hidden;
            background: none;
        }
    }
}
</style>